/** Free-trial duration used for paywall disclaimer end datetime. */
export const ONBOARDING_PAYWALL_TRIAL_DAYS = 7;

/** Figma `96138:32738` — Paywall – Free trial (H5). */
export const ONBOARDING_PAYWALL_FREE_TRIAL_FIGMA_NODE = "96138:32738";

/** PC fallback when no dedicated Free trial frame exists. */
export const ONBOARDING_PAYWALL_FREE_TRIAL_PC_FALLBACK_NODE = "96344:111117";

/** V3.0.3 paywall hero — H5. */
export const ONBOARDING_PAYWALL_HERO_IMAGE_MOBILE =
  "/assets/images/paywall-hero-bg-mobile.webp";

/** V3.0.3 paywall hero — PC. */
export const ONBOARDING_PAYWALL_HERO_IMAGE_DESKTOP =
  "/assets/images/paywall-hero-bg-desktop.webp";

/** Defaults to H5 hero; prefer {@link resolveOnboardingPaywallHeroImage}. */

export function resolveOnboardingPaywallHeroImage(isPc: boolean): string {
  return isPc
    ? ONBOARDING_PAYWALL_HERO_IMAGE_DESKTOP
    : ONBOARDING_PAYWALL_HERO_IMAGE_MOBILE;
}

/** Figma Scrim multi-stop gradient (node `96097:351634`). */
export const ONBOARDING_PAYWALL_SCRIM_GRADIENT =
  "linear-gradient(rgba(28, 18, 8, 0.52) 0%, rgba(28, 18, 8, 0.22) 10%, rgba(28, 18, 8, 0) 20%, rgba(28, 18, 8, 0.07) 32%, rgba(28, 18, 8, 0.34) 50%, rgba(28, 18, 8, 0.62) 72%, rgba(28, 18, 8, 0.92) 100%)";

export const ONBOARDING_PAYWALL_SCROLL_CLASS =
  "relative z-10 min-h-0 flex-1 overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch]";

export const ONBOARDING_PAYWALL_FOOTER_CLASS =
  "shrink-0 rounded-t-3 bg-background_solid_neutral_primary pb-safe";

/** Figma Status Bar `I96097:351636;7874:46947` height (~46px). */
export const ONBOARDING_PAYWALL_STATUS_BAR_FALLBACK_PX = 10;
